import { render, staticRenderFns } from "./AdminSurveySelector.vue?vue&type=template&id=4c5f76fa&"
import script from "./AdminSurveySelector.vue?vue&type=script&lang=js&"
export * from "./AdminSurveySelector.vue?vue&type=script&lang=js&"
import style0 from "./AdminSurveySelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports